module.exports = __webpack_public_path__ + "static/media/spinner_stars_2.bcfcd41b.svg";